


























































import { Component, Mixins, Vue } from "vue-property-decorator";
import { getRequestHistory, RequestHistoryResponse } from "@/apis";
import ContainImage from "@/components/ContainImage.vue";
import ImageButton from "@/components/ImageButton.vue";
import TextLabel from "@/components/TextLabel.vue";
import Overlay from "@/components/Overlay.vue";
import SettingMixin from "@/mixins/settingMixin";
import Moment from "moment";

@Component({
  components: {
    ContainImage,
    ImageButton,
    TextLabel,
    Overlay,
  },
  filters: {
    dateFormat: (timeptamp: string, format: string) => {
      Moment.locale("ja");
      return Moment(timeptamp).format(format);
    },
  },
})
export default class RequestHistory extends Mixins(Vue, SettingMixin) {
  requestHistories: RequestHistoryResponse[] = [];
  isWin = false;
  isMounted = false;

  incentiveUrl = "";

  get requestHistoryHeader(): string {
    return this.config.imageName.requestHistory?.requestHistoryHeader
      ? `./images/campaign/${this.config.imageName.requestHistory.requestHistoryHeader}`
      : "";
  }
  get deliveryInfo(): string {
    return this.config.imageName.requestHistory?.deliveryInfo
      ? `./images/campaign/${this.config.imageName.requestHistory.deliveryInfo}`
      : "";
  }
  get goToTopPage(): string {
    return this.config.imageName.requestHistory?.goToTopPage
      ? `./images/campaign/${this.config.imageName.requestHistory.goToTopPage}`
      : "";
  }

  openInformationPage(): void {
    window.open(this.incentiveUrl);
  }

  async mounted(): Promise<void> {
    const isOpen = await this.checkCampaignStatus();
    if (!isOpen) return;
    // postActionLog(this.campaignId, "apply_history", this.token);
    try {
      const res = await getRequestHistory(this.campaignId, this.token);
      if (!res) return;
      this.requestHistories = res.data.request_history;

      const win = res.data.request_history.find(
        (x: RequestHistoryResponse) =>
          x.won && x.course_group_id === this.courseGroupEnv.collab.id
      );
      this.isWin = !!win;
      this.incentiveUrl = win?.incentive_url ?? "";
      this.isMounted = true;
    } catch (e) {
      this.routerPushSystemErrorPage();
    }
  }
}
